import React from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { LS_ACCESS_TOKEN_KEY } from '../constants/common';

const RedirectToLogin = () => {
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const queryParams = new URLSearchParams(location.search);

    const redirectParam = searchParams.get('redirect');
    const period = searchParams.get('period');
    const accessToken = localStorage.getItem(LS_ACCESS_TOKEN_KEY);
    if (accessToken && redirectParam === 'qualitative') {
       return <Navigate replace to={`/company_admin/qualitative${period ? `?period=${period}` : ''}`} />;
    } else {
        const urlQParams = queryParams ? `?${queryParams.toString()}`: '';
        return <Navigate replace to={`/login${urlQParams}`} />;
    }    
};

export default RedirectToLogin;